import { ErrorEmptyState } from '@/pages/error-pages/error-empty-state/error-empty-state'

export const UnknownError = () => {
  return <ErrorEmptyState title='Sorry, something went wrong.' />
}
